import { types } from '~/utils/typeCreator'

export default types(['SET_FEEDBACK', 'CLEAR_STATE'], 'FEEDBACK')
